<template>
  <div id="contenedor-eliminar-licitacion-participante">
      <v-card>
          <v-card-title class="secondary--text">
              Desea eliminar al participante?
          </v-card-title>
          <v-card-text>
            <span
              class="secondary--text">
              {{ participanteEliminar.contratista.nombreRazonSocial }}
            </span>
          </v-card-text>
          <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3"
          >
          </custom-button>
          <custom-button
            @click="mixEliminarLicitacionParticipante"
            :disabled="enviandoFormulario"
            tipo="formAceptar"
            label="Eliminar"
          >
          </custom-button>
        </v-card-actions>
      </v-card>
  </div>
</template>

<script>
import mixParticipantes from './mixParticipantes';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EliminarLicitacionParticipante',
  mixins: [mixParticipantes],
  props: {
    participanteEliminar: Object,
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },

};
</script>

<style>

</style>
